import { Component, Inject } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { SelectEvent } from '@progress/kendo-angular-upload';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { FileModel } from '../../../../shared/model/file.model';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { AssetService } from '../../service/asset.service';
import { AssetAttachmentModel } from '../model/asset-attachment.model';
import { AssetPhotoUploadModel } from '../model/asset-photo-upload.model';
import { AssetUIMessages } from '../model/asset-ui.messages';

@Component({
  selector: 'asset-photo-upload-progress-dialog',
  templateUrl:
    'console/app-js/modules/asset/components/asset-photo-upload-progress-dialog/asset-photo-upload-progress-dialog.component.html'
})
export class AssetPhotoUploadProgressDialog extends APIOperableComponent {
  public isProgressbar: boolean;
  public isShowSubType: boolean = true;
  public isChecked: boolean = true;
  public subtype: string = 'asset';
  private uploadFileModel: AssetPhotoUploadModel;
  public maxFileSize: number = 26214400;

  constructor(
    @Inject('selectEvent') assetPhotoUploadModel: AssetPhotoUploadModel,
    public activeDialogService: UIActiveDialogService,
    private assetService: AssetService,
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService
  ) {
    super(progressService, toastr, authService);
    this.uploadFileModel = assetPhotoUploadModel;
  }

  onCancel(): void {
    this.activeDialogService.dismiss();
  }
  onSubmit() {
    this.isShowSubType = false;
    this.isProgressbar = true;
    this.readFile(this.uploadFileModel.selectEvent, this.subtype);
  }

  onSelectionChange(value: any) {
    this.subtype = value;
  }

  private readFile(event: SelectEvent, assetType: string): void {
    const self = this;
    let _filename: string;
    event.files.forEach((file: any) => {
      if (file.validationErrors) {
        this.onAPIError(AssetUIMessages.DEACTIVATE_FILE_EXTENSION_ERROR);
        this.activeDialogService.close(false);
      } else if (file.size > this.maxFileSize) {
        this.onAPIError(AssetUIMessages.DEACTIVATE_FILE_SIZE_ERROR);
        this.activeDialogService.close(false);
      } else {
        _filename = file.rawFile
          ? file.rawFile.name.replace(/[^\.a-zA-Z0-9 ]/g, '') //CommonUtils.ReplaceSpecialChar(file.rawFile.name)
          : '';
        const reader = new FileReader();
        let fileObject = new FileModel();
        reader.onload = function(e: any) {
          (fileObject.filename = _filename),
            (fileObject.file = e.target.result.replace(
              /^data:[a-z\^\/\.\-]+;base64,/,
              ''
            )),
            (fileObject.description = _filename),
            (fileObject.size = e.total);
          self.uploadAssetPhoto(fileObject, assetType);
        };
        reader.readAsDataURL(file.rawFile);
      }
    });
  }

  uploadAssetPhoto(file: FileModel, assetType: string) {
    this.assetService.postFileUpload(file).subscribe(
      (res: any) => {
        console.log(!res.key);
        if (res && res.key) {
          let assetAttachment = new AssetAttachmentModel();
          assetAttachment.key = res.key;
          assetAttachment.subType = assetType;
          this.assetService
            .postAssetAttachment(this.uploadFileModel.assetId, assetAttachment)
            .subscribe(
              (assetAttachmentResponse: any) => {
                if (
                  assetAttachmentResponse &&
                  assetAttachmentResponse.errorMessage
                ) {
                  this.onAPIError(
                    AssetUIMessages.DEACTIVATE_ASSET_ATTACHMENT_ERROR
                  );
                  this.activeDialogService.close(false);
                } else {
                  this.activeDialogService.close(true);
                }
              },
              () => {
                this.onAPIError(
                  AssetUIMessages.DEACTIVATE_ASSET_ATTACHMENT_ERROR
                );
                this.activeDialogService.close(false);
              }
            );
        } else {
          this.onAPIError(AssetUIMessages.DEACTIVATE_FILE_UPLOAD_ERROR);
          this.activeDialogService.close(false);
        }
      },
      () => {
        this.onAPIError(AssetUIMessages.DEACTIVATE_FILE_UPLOAD_ERROR);
        this.activeDialogService.close(false);
      }
    );
  }
}
